import { h, Host } from "@stencil/core";
/**
 * The 'ch-window-close' component represents the close button for the 'ch-window' component.
 */
export class ChWindowClose {
    constructor() {
        this.disabled = undefined;
    }
    /** Emitted when the close button is clicked. */
    windowCloseClicked;
    pressedHandler(eventInfo) {
        if (!eventInfo.key || eventInfo.key === "Enter" || eventInfo.key === " ") {
            this.windowCloseClicked.emit();
            eventInfo.stopPropagation();
        }
    }
    render() {
        return h(Host, { key: '9603b8bd74dcfbc32e1a7296a96e0afc9f0b120f', role: "button", tabindex: "0", disabled: this.disabled });
    }
    static get is() { return "ch-window-close"; }
    static get originalStyleUrls() {
        return {
            "$": ["ch-window-close.scss"]
        };
    }
    static get styleUrls() {
        return {
            "$": ["ch-window-close.css"]
        };
    }
    static get properties() {
        return {
            "disabled": {
                "type": "boolean",
                "mutable": false,
                "complexType": {
                    "original": "boolean",
                    "resolved": "boolean",
                    "references": {}
                },
                "required": false,
                "optional": false,
                "docs": {
                    "tags": [],
                    "text": "Specifies whether the close button is disabled."
                },
                "attribute": "disabled",
                "reflect": false
            }
        };
    }
    static get events() {
        return [{
                "method": "windowCloseClicked",
                "name": "windowCloseClicked",
                "bubbles": true,
                "cancelable": true,
                "composed": true,
                "docs": {
                    "tags": [],
                    "text": "Emitted when the close button is clicked."
                },
                "complexType": {
                    "original": "any",
                    "resolved": "any",
                    "references": {}
                }
            }];
    }
    static get listeners() {
        return [{
                "name": "keydown",
                "method": "pressedHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }, {
                "name": "click",
                "method": "pressedHandler",
                "target": undefined,
                "capture": false,
                "passive": true
            }];
    }
}
